interface LogoProps {
  size?: number;
}

export function Logo({ size = 40 }: LogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect width="72" height="72" rx="18" fill="#087B63" />
      <path
        d="M21 51 32.9 22h6.2L51 51"
        stroke="#F7FCFA"
        strokeWidth="7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M28.5 41h15" stroke="#F7FCFA" strokeWidth="6" strokeLinecap="round" />
      <circle cx="50" cy="49" r="12" fill="#F7FCFA" stroke="#087B63" strokeWidth="3" />
      <path
        d="m44.5 49.2 3.6 3.7 7.5-8.2"
        stroke="#087B63"
        strokeWidth="3.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
